<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(submit)">
      <div class="md-layout">
        <div class="md-layout-item md-size-100">
          <md-card>
            <md-card-header class="md-card-header-icon md-card-header-green">
              <div class="card-icon clickable" @click="close()">
                <md-icon>arrow_back</md-icon>
              </div>
              <h4 class="title">Thông tin chi tiết</h4>
            </md-card-header>
            <md-card-content class="md-layout">
              <div class="md-layout-item md-size-50 md-xsmall-size-100">
                <md-field>
                  <div class="md-layout-item md-size-20">
                    <md-button
                      class="md-success button-addImg md-dense"
                      @click="referToInputPickFile"
                    >
                      Thêm ảnh
                      <md-tooltip>Thêm ảnh mô tả</md-tooltip>
                    </md-button>
                  </div>
                </md-field>
                <div class="md-layout">
                  <div
                    :key="index"
                    v-for="(items, index) in form.pictureUrl"
                    class="add-img md-size-30 md-layout-item container"
                  >
                    <img
                      :src="items.url"
                      style="height: 100px; width: auto; margin: auto"
                      class="image"
                    />
                    <div class="middle clickable" @click="removeImg(items)">
                      <div class="text"><i class="fas fa-trash-alt"></i></div>
                    </div>
                  </div>
                  <div
                    class="md-layout-item md-size-33"
                    v-show="progress !== 100"
                  >
                    <h4 class="card-title">
                      {{ Math.floor(progress) + " %" }}
                    </h4>
                    <md-progress-bar
                      class="md-primary"
                      :md-value="progress"
                    ></md-progress-bar>
                  </div>
                </div>
                <input
                  id="iconImage"
                  @change="addImg"
                  type="file"
                  accept="image/png, image/jpeg"
                  ref="inputFile"
                  style="display: none"
                />
              </div>
              <div class="md-layout-item md-size-50 md-xsmall-size-100">
                <md-field>
                  <div class="md-layout-item md-size-20">
                    <md-button
                      class="md-success button-addImg md-dense"
                      @click="referToInputPickFileThumbnail"
                    >
                      Tải ảnh đại diện
                      <md-tooltip>Tải ảnh đại diện cho sản phẩm</md-tooltip>
                    </md-button>
                  </div>
                </md-field>
                <div class="md-layout container" style="padding: 10px">
                  <img
                    v-if="form.pictureThumbnail"
                    :src="form.pictureThumbnail"
                    style="height: 100px; width: auto; margin: auto"
                    class="image"
                  />
                  <div
                    class="middle clickable"
                    @click="form.pictureThumbnail = ''"
                  >
                    <div class="text"><i class="fas fa-trash-alt"></i></div>
                  </div>
                </div>
                <input
                  id="iconImage"
                  @change="addImgThumbnail"
                  type="file"
                  accept="image/png, image/jpeg"
                  ref="inputFileThumbnail"
                  style="display: none"
                />
              </div>
            </md-card-content>
          </md-card>
        </div>
        <div class="md-layout-item md-size-33 md-small-size-100">
          <md-card style="height: 95%">
            <md-card-header>
              <h4 class="title">Thông tin nhận diện</h4>
            </md-card-header>
            <md-card-content>
              <div class="md-layout-item md-xsmall-size-100">
                <ValidationProvider
                  name="required"
                  rules="required"
                  v-slot="{ passed, failed }"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <md-icon>fingerprint</md-icon>
                    <label>Mã sản phẩm:</label>
                    <md-input
                      @change="isChange = true"
                      v-model="form.productId"
                      type="text"
                      required
                      :disabled="productSelected.id"
                    ></md-input>
                    <slide-y-down-transition>
                      <md-icon class="error" v-show="failed">close</md-icon>
                    </slide-y-down-transition>
                    <slide-y-down-transition>
                      <md-icon class="success" v-show="passed">done</md-icon>
                    </slide-y-down-transition>
                  </md-field>
                </ValidationProvider>
              </div>
              <div class="md-layout-item md-xsmall-size-100">
                <md-field>
                  <md-icon>fingerprint</md-icon>
                  <label>BARCODE:</label>
                  <md-input
                    @change="isChange = true"
                    v-model="form.barCode"
                    type="text"
                  ></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-xsmall-size-100">
                <ValidationProvider
                  name="required"
                  rules="required"
                  v-slot="{ passed, failed }"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <md-icon>local_bar</md-icon>
                    <label>Tên sản phẩm:</label>
                    <md-input
                      @change="isChange = true"
                      v-model="form.name"
                      type="text"
                      required
                      :disabled="productSelected.id"
                    ></md-input>
                    <slide-y-down-transition>
                      <md-icon class="error" v-show="failed">close</md-icon>
                    </slide-y-down-transition>
                    <slide-y-down-transition>
                      <md-icon class="success" v-show="passed">done</md-icon>
                    </slide-y-down-transition>
                  </md-field>
                </ValidationProvider>
              </div>
            </md-card-content>
          </md-card>
        </div>
        <div class="md-layout-item md-size-66 md-small-size-100">
          <md-card style="height: 95%">
            <md-card-header>
              <h4 class="title">Đặc điểm, tính chất</h4>
            </md-card-header>
            <md-card-content class="md-layout">
              <div class="md-layout-item md-size-50 md-xsmall-size-100">
                <div class="md-layout-item md-xsmall-size-100">
                  <md-autocomplete
                    @change="isChange = true"
                    v-model="form.origin"
                    :md-options="suggestion.origin"
                    :md-open-on-focus="true"
                  >
                    <label>Xuất xứ:</label>
                  </md-autocomplete>
                </div>
                <div class="md-layout">
                  <div class="md-layout-item md-xsmall-size-100">
                    <md-field>
                      <vue-tags-input
                        @change="isChange = true"
                        placeholder="Chủng loại"
                        class="vue-tags-input"
                        style="width: 100%"
                        v-model="tags.type"
                        :tags="tag.type"
                        @tags-changed="(newTags) => (tag.type = newTags)"
                      />
                    </md-field>
                  </div>
                </div>
                <div class="md-layout">
                  <div class="md-layout-item md-xsmall-size-100">
                    <md-field>
                      <vue-tags-input
                        @change="isChange = true"
                        placeholder="Thêm giống nho"
                        class="vue-tags-input"
                        style="width: 100%"
                        v-model="tags.grapeVariety"
                        :tags="tag.grapeVariety"
                        @tags-changed="
                          (newTags) => (tag.grapeVariety = newTags)
                        "
                        :autocomplete-items="filteredGrapeVariety"
                      />
                    </md-field>
                  </div>
                </div>
                <div class="md-layout">
                  <div class="md-layout-item md-xsmall-size-100">
                    <md-field>
                      <vue-tags-input
                        @change="isChange = true"
                        placeholder="Vùng trồng nho"
                        class="vue-tags-input"
                        style="width: 100%"
                        v-model="tags.area"
                        :tags="tag.area"
                        @tags-changed="(newTags) => (tag.area = newTags)"
                        :autocomplete-items="filteredArea"
                      />
                    </md-field>
                  </div>
                </div>
              </div>
              <div class="md-layout-item md-size-50 md-xsmall-size-100">
                <div class="md-layout">
                  <div class="md-layout-item md-xsmall-size-100">
                    <md-field>
                      <vue-tags-input
                        @change="isChange = true"
                        placeholder="Gợi ý món ăn"
                        class="vue-tags-input"
                        style="width: 100%"
                        v-model="tags.foodPairing"
                        :tags="tag.foodPairing"
                        @tags-changed="(newTags) => (tag.foodPairing = newTags)"
                        :autocomplete-items="filteredFoodPairing"
                      />
                    </md-field>
                  </div>
                </div>
                <div class="md-layout">
                  <div class="md-layout-item md-xsmall-size-100">
                    <md-field>
                      <vue-tags-input
                        @change="isChange = true"
                        placeholder="Thêm màu sắc"
                        class="vue-tags-input"
                        style="width: 100%"
                        v-model="tags.color"
                        :tags="tag.color"
                        @tags-changed="(newTags) => (tag.color = newTags)"
                        :autocomplete-items="filteredColor"
                      />
                    </md-field>
                  </div>
                </div>
                <div class="md-layout">
                  <div class="md-layout-item md-xsmall-size-100">
                    <md-field>
                      <vue-tags-input
                        @change="isChange = true"
                        placeholder="Mùi vị"
                        class="vue-tags-input"
                        style="width: 100%"
                        v-model="tags.flavor"
                        :tags="tag.flavor"
                        @tags-changed="(newTags) => (tag.flavor = newTags)"
                        :autocomplete-items="filteredFlavor"
                      />
                    </md-field>
                  </div>
                </div>
              </div>
            </md-card-content>
          </md-card>
        </div>
        <div class="md-layout-item md-size-100">
          <md-card>
            <md-card-content class="md-layout">
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field>
                  <label>Nồng độ cồn:</label>
                  <md-input
                    @change="isChange = true"
                    v-model="form.alcoholPercentage"
                    type="text"
                  ></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field>
                  <label>Mức độ đậm đà:</label>
                  <md-select
                    @change="isChange = true"
                    v-model="form.qualities.body"
                  >
                    <md-option
                      v-for="(item, index) in level"
                      :key="item"
                      :value="index"
                      >{{ item }}</md-option
                    >
                  </md-select>
                </md-field>
              </div>
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field>
                  <label>Mức độ tanin:</label>
                  <md-select
                    @change="isChange = true"
                    v-model="form.qualities.tannic"
                  >
                    <md-option
                      v-for="(item, index) in level"
                      :key="item"
                      :label="item"
                      :value="index"
                      >{{ item }}</md-option
                    >
                  </md-select>
                </md-field>
              </div>
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field>
                  <label>Mức độ chất ngọt:</label>
                  <md-select
                    @change="isChange = true"
                    v-model="form.qualities.sweetness"
                  >
                    <md-option
                      v-for="(item, index) in level"
                      :key="item"
                      :label="item"
                      :value="index"
                      >{{ item }}</md-option
                    >
                  </md-select>
                </md-field>
              </div>
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field>
                  <label>Mức độ chất chua:</label>
                  <md-select
                    @change="isChange = true"
                    v-model="form.qualities.acidity"
                  >
                    <md-option
                      v-for="(item, index) in level"
                      :key="item"
                      :label="item"
                      :value="index"
                      >{{ item }}</md-option
                    >
                  </md-select>
                </md-field>
              </div>
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field>
                  <label>Hàm lượng bọt khí:</label>
                  <md-select @change="isChange = true" v-model="form.fizziness">
                    <md-option
                      v-for="(item, index) in level"
                      :key="item"
                      :label="item"
                      :value="index"
                      >{{ item }}</md-option
                    >
                  </md-select>
                </md-field>
              </div>
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field>
                  <label>Năm thu hoạch</label>
                  <md-input
                    @change="isChange = true"
                    v-model="form.harvestTime"
                    type="number"
                    min="0"
                  ></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field>
                  <label>Nhiệt độ sử dụng:</label>
                  <md-input
                    @change="isChange = true"
                    v-model="form.servingTemp"
                    type="text"
                  ></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field>
                  <label>Decanting:</label>
                  <md-input
                    @change="isChange = true"
                    v-model="form.decanting"
                    type="text"
                  ></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field>
                  <label>Thời điểm sử dụng tốt nhất:</label>
                  <md-input
                    @change="isChange = true"
                    v-model="form.servingTime"
                    type="text"
                  ></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field>
                  <label>Giải thưởng/Điểm số:</label>
                  <md-input
                    @change="isChange = true"
                    v-model="form.awards"
                    type="text"
                  ></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field>
                  <label>Cấp độ theo quy định:</label>
                  <md-input
                    @change="isChange = true"
                    v-model="form.levelPrescribed"
                    type="text"
                    min="0"
                  ></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field>
                  <label>Phương pháp làm rượu:</label>
                  <md-input
                    @change="isChange = true"
                    v-model="form.score"
                  ></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field>
                  <vue-tags-input
                    @change="isChange = true"
                    placeholder="Quy cách đóng gói"
                    class="vue-tags-input"
                    style="width: 100%"
                    v-model="tags.packMethods"
                    :tags="tag.packMethods"
                    @tags-changed="(newTags) => (tag.packMethods = newTags)"
                    :autocomplete-items="filteredPackMethods"
                  />
                </md-field>
              </div>
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-autocomplete
                  @change="isChange = true"
                  v-model="form.manufacturer"
                  :md-options="suggestion.manufacturer"
                  :md-open-on-focus="true"
                >
                  <label>Nhà sản xuất:</label>
                </md-autocomplete>
              </div>
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-autocomplete
                  @change="isChange = true"
                  v-model="form.importer"
                  :md-options="suggestion.importer"
                  :md-open-on-focus="true"
                  md-require-match
                >
                  <label>Nhà nhập khẩu:</label>
                </md-autocomplete>
              </div>
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-autocomplete
                  @change="isChange = true"
                  v-model="form.distributor"
                  :md-options="suggestion.distributor"
                  :md-open-on-focus="true"
                >
                  <label>Nhà phân phối:</label>
                </md-autocomplete>
              </div>
            </md-card-content>
          </md-card>
        </div>
        <div class="md-layout-item md-size-100">
          <md-card>
            <md-card-header>
              <h4>Thông tin thanh toán</h4>
            </md-card-header>
            <md-card-content class="md-layout">
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field>
                  <label>Tỷ lệ chiết khấu:</label>
                  <md-input
                    @change="isChange = true"
                    v-model="form.discountValue"
                    type="number"
                    min="0"
                  ></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field>
                  <label>Tỷ lệ khuyến mãi:</label>
                  <md-input
                    @change="isChange = true"
                    v-model="form.saleOffValue"
                    type="number"
                    min="0"
                  ></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field>
                  <label>Giá bán lẻ đề xuất:</label>
                  <md-input
                    @change="isChange = true"
                    v-model="form.price"
                    type="number"
                    required
                    min="0"
                  ></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field>
                  <label>Số lượng hàng trong kho:</label>
                  <md-input
                    @change="isChange = true"
                    v-model="form.warehouse"
                    type="number"
                    min="0"
                    disabled
                  ></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field>
                  <label>Đơn vị tính:</label>
                  <md-input
                    @change="isChange = true"
                    v-model="form.unit"
                  ></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-field>
                  <label md-inline="true">Hướng dẫn bảo quản:</label>
                  <md-input
                    @change="isChange = true"
                    v-model="form.preservationManual"
                    type="text"
                  ></md-input>
                </md-field>
              </div>
            </md-card-content>
          </md-card>
        </div>
      </div>
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <h4>Bài viết:</h4>
        </md-card-header>
        <md-card-content class="md-layout">
          <div class="md-layout-item md-size-100 md-xsmall-size-100">
            <!-- <div class="md-layout">
              <div class="md-layout-item md-xsmall-size-100">
                <md-field>
                  <vue-tags-input
                    placeholder="Tags"
                    class="vue-tags-input"
                    style="width: 100%;"
                    v-model="tags.tags"
                    :tags="tag.tags"
                    @tags-changed="newTags => (tag.tags = newTags)"
                    :autocomplete-items="filteredTags"
                  />
                </md-field>
              </div>
            </div>-->
            <div
              class="md-layout-item md-xsmall-size-100 box-image md-elevation-7"
            >
              <h4 class="title">Bài viết 1:</h4>
              <md-field>
                <md-textarea
                  @change="isChange = true"
                  v-model="additionalInfo1[0]"
                  :md-autogrow="true"
                ></md-textarea>
                <md-icon>description</md-icon>
              </md-field>
            </div>
            <div
              class="md-layout-item md-xsmall-size-100 box-image md-elevation-7"
            >
              <h4>Bài viết 2:</h4>
              <md-field>
                <md-textarea
                  @change="isChange = true"
                  v-model="additionalInfo1[1]"
                  :md-autogrow="true"
                ></md-textarea>
                <md-icon>description</md-icon>
              </md-field>
            </div>
            <div
              class="md-layout-item md-xsmall-size-100 box-image md-elevation-7"
            >
              <h4>Bài viết 3:</h4>
              <md-field>
                <md-textarea
                  @change="isChange = true"
                  v-model="additionalInfo1[2]"
                  :md-autogrow="true"
                ></md-textarea>
                <md-icon>description</md-icon>
              </md-field>
            </div>
          </div>
        </md-card-content>
        <md-card-actions>
          <md-button type="submit" class="md-success" :disabled="flagLoading"
            >Hoàn tất</md-button
          >
          <md-button class="md-danger" style="margin-left: 10px" @click="close"
            >Đóng</md-button
          >
        </md-card-actions>
      </md-card>
    </form>
  </ValidationObserver>
</template>
<script>
import { VueTagsInput, createTags } from "@johmun/vue-tags-input";
import { SlideYDownTransition } from "vue2-transitions";
import { extend } from "vee-validate";
import { required, numeric, regex, confirmed } from "vee-validate/dist/rules";
import Swal from "sweetalert2";
import DAO from "@/DAO.js";
import firebase from "@/services/firebase-init.js";
import storage from "firebase/storage";
import { mapGetters } from "vuex";
import Compressor from "compressorjs";

extend("required", required);
extend("numeric", numeric);
extend("regex", regex);
extend("confirmed", confirmed);

export default {
  components: {
    SlideYDownTransition,
    VueTagsInput,
  },
  data() {
    return {
      productSelected: {},
      ref: null,
      isChange: false,
      progress: 100,
      storageRef: {},
      form: {
        additionalInfo: "",
        barCode: "",
        unit: "Chai",
        warehouse: 0,
        preservationManual: "",
        additionalInfo: "",
        pictureThumbnail: "",
        name: "",
        productId: "",
        origin: "",
        pictureUrl: [],
        price: 0,
        saleOffValue: 0,
        servingTemp: "",
        servingTime: "",
        type: [],
        importer: "CIE",
        fizziness: 0,
        qualities: {
          body: 0,
          tannic: 0,
          sweetness: 0,
          acidity: 0,
        },
        grapeVariety: [],
        foodPairing: [],
        color: [],
        flavor: [],
        area: [],
        packMethods: [],
        tags: ["Rượu"],
        alcoholPercentage: "0",
        discountValue: 0,
        harvestTime: "20",
        manufacturer: "",
        score: "",
      },
      tag: {
        type: [],
        grapeVariety: [],
        foodPairing: [],
        color: [],
        flavor: [],
        area: [],
        packMethods: [],
        tags: [],
        type: [],
      },
      tags: {
        type: "",
        grapeVariety: "",
        foodPairing: "",
        color: "",
        flavor: "",
        area: "",
        packMethods: "",
        tags: "",
        type: "",
      },
      suggestion: {
        area: [],
        distributor: [],
        grapeVariety: [],
        importer: [],
        manufacturer: [],
        origin: [],
        packMethods: [],
        type: [],
        foodPairing: [],
        color: [],
        flavor: [],
        tags: [],
      },
      img: "",
      level: [
        "N/A",
        "* (Low)",
        "** (Medium low)",
        "*** (Medium)",
        "**** (Medium high)",
        "***** (High)",
      ],
      db: {},
      constWarehouse: 0,
      additionalInfo1: [],
      imageSelected: null,
    };
  },
  created() {
    var storage = firebase.storage();
    this.db = firebase.firestore();
    if (this.$route.query.id) {
      this.$store.dispatch("FLAG_LOADING", true);
      let bits = localStorage.getItem("bits");
      this.db
        .collection(process.env.VUE_APP_WINE + bits)
        .doc(this.$route.query.id)
        .get()
        .then((doc) => {
          if (doc.exists) {
            this.productSelected.id = doc.id;
            this.form = doc.data();
            this.additionalInfo1 = doc
              .data()
              .additionalInfo.split("$jointPoint");
            console.log(doc.data().additionalInfo);
          } else this.$store.dispatch("FLAG_LOADING", false);
          this.$store.dispatch("FLAG_LOADING", false);
          // this.$data.constWarehouse = this.productSelected.data.warehouse;
          this.id = this.productSelected.id;
          this.tag.area = createTags(this.form.area);
          this.tag.grapeVariety = createTags(this.form.grapeVariety);
          this.tag.foodPairing = createTags(this.form.foodPairing);
          this.tag.color = createTags(this.form.color);
          this.tag.flavor = createTags(this.form.flavor);
          this.tag.packMethods = createTags(this.form.packMethods);
          this.tag.tags = createTags(this.form.tags);
          this.tag.type = createTags(this.form.type);
          this.storageRef = firebase
            .storage()
            .ref("Products")
            .child(this.productSelected.id);
        })
        .catch((error) => {
          console.log(error);
          this.$store.dispatch("FLAG_LOADING", false);
        });
    } else {
      let bits = localStorage.getItem("bits");
      this.ref = this.db.collection(process.env.VUE_APP_WINE + bits).doc();
      this.storageRef = firebase.storage().ref("Products").child(this.ref.id);
    }
    DAO.getDocumentFromFireStore(
      firebase.firestore(),
      process.env.VUE_APP_SUGGESTION_LIST,
      "Products"
    ).then((doc) => {
      this.suggestion = doc;
    });
  },
  methods: {
    referToInputPickFile() {
      this.$refs.inputFile.click();
    },
    addImg(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return false;
      } else if (
        files[0].type !== "image/jpeg" &&
        files[0].type !== "image/png" &&
        files[0].type !== "image/jpg"
      ) {
        this.$notify({
          timeout: 3000,
          type: "warning",
          message: "Chỉ cho phép ảnh định dạng jpeg, png hoặc jpg! Thử lại!",
          icon: "add_alert",
          horizontalAlign: "right",
          verticalAlign: "top",
        });
      } else {
        this.uploadImg(files[0]);
      }
    },
    async uploadImg(file) {
      var fileReader = new FileReader();
      var _this = this;
      fileReader.onload = function (event) {
        var imagesRef = _this.storageRef.child(new Date().valueOf().toString());
        // _this.upLoadThumbnail(file);
        imagesRef.put(file).on(
          "state_changed",
          (snapshot) => {
            var progress =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            _this.progress = progress;
          },
          (error) => {
            this.$messageError(error.message);
          },
          () => {
            _this.$messageSuccess("Tải ảnh lên thành công");
            imagesRef.getDownloadURL().then((downloadURL) => {
              _this.form.pictureUrl.push({
                ref: imagesRef.location.path,
                url: downloadURL,
              });
              let bits = localStorage.getItem("bits");
              _this.db
                .collection(process.env.VUE_APP_WINE + bits)
                .doc(_this.productSelected.id)
                .update({ pictureUrl: _this.form.pictureUrl })
                .then();
            });
          }
        );
      };
      fileReader.readAsDataURL(file);
    },
    referToInputPickFileThumbnail() {
      this.$refs.inputFileThumbnail.click();
    },
    addImgThumbnail(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return false;
      } else if (
        files[0].type !== "image/jpeg" &&
        files[0].type !== "image/png" &&
        files[0].type !== "image/jpg"
      ) {
        this.$notify({
          timeout: 3000,
          type: "warning",
          message: "Chỉ cho phép ảnh định dạng jpeg, png hoặc jpg! Thử lại!",
          icon: "add_alert",
          horizontalAlign: "right",
          verticalAlign: "top",
        });
      } else {
        this.upLoadThumbnail(files[0]);
      }
    },
    upLoadThumbnail(file) {
      let _this = this;
      new Compressor(file, {
        maxWidth: 250,
        quality: 0.8,
        convertSize: 30000,
        mimeType: "image/png",
        success(result) {
          var fileReader = new FileReader();
          fileReader.readAsDataURL(result);
          fileReader.onload = function (event) {
            _this.form.pictureThumbnail = event.target.result;
            let bits = localStorage.getItem("bits");
            _this.db
              .collection(process.env.VUE_APP_WINE + bits)
              .doc(_this.productSelected.id)
              .update({ pictureThumbnail: _this.form.pictureThumbnail })
              .then();
          };
        },
        error(err) {},
      });
    },
    removeImg(item) {
      var desertRef = firebase.storage().ref(item.ref);
      desertRef
        .delete()
        .then(() => {
          this.$messageSuccess("Đã xóa ảnh khỏi cơ sở dữ liệu");
        })
        .catch((error) => {
          console.log(error);
        });
      this.form.pictureUrl.splice(this.form.pictureUrl.indexOf(item), 1);
      if (this.productSelected.id) {
        let bits = localStorage.getItem("bits");
        this.db
          .collection(process.env.VUE_APP_WINE + bits)
          .doc(this.productSelected.id)
          .update(this.form)
          .then();
      }
    },
    addProduct() {
      this.updateTags();
      this.updateSuggestion();
      this.$store.dispatch("FLAG_LOADING", true);
      let date = new Date();
      this.form.creationTime = date.valueOf();
      this.form.warehouse = this.form.warehouse ? this.form.warehouse : 0;
      this.form.discountValue = this.form.discountValue
        ? this.form.discountValue
        : 0;
      this.form.saleOffValue = this.form.saleOffValue
        ? this.form.saleOffValue
        : 0;
      this.form.additionalInfo =
        this.additionalInfo1[0] +
        "$jointPoint" +
        this.additionalInfo1[1] +
        "$jointPoint" +
        this.additionalInfo1[2];
      this.ref.set(this.form).then(() => {
        Swal.fire({
          title: "Thành công",
          text: "Đã thêm thông tin sản phẩm",
          timer: 800,
          showConfirmButton: false,
        });
        this.$store.commit("GET_PRODUCT", this.ref.id);
        this.$store.dispatch("FLAG_LOADING", false);
        this.$router.push({ name: "Quản lý sản phẩm" });
      });
    },
    checkDuplicateName() {
      var bits = localStorage.getItem("bits");
      this.db
        .collection(process.env.VUE_APP_WINE + bits)
        .where("name", "==", this.form.name)
        .get()
        .then(async (querySnapshot) => {
          let check = true;
          await querySnapshot.forEach((doc) => {
            if (doc.id) {
              this.$messageError("Trùng tên sản phẩm");
              check = false;
            }
          });
          if (check) this.addProduct();
        });
    },
    checkIsExist() {
      let check = false;
      var bits = localStorage.getItem("bits");
      this.db
        .collection(process.env.VUE_APP_WINE + bits)
        .where("productId", "==", this.form.productId)
        .get()
        .then((querySnapshot) => {
          let check = true;
          querySnapshot.forEach((doc) => {
            if (doc.id) {
              this.$messageError("Trùng mã sản phẩm");
              check = false;
            }
          });
          if (check) this.checkDuplicateName();
        });
    },
    submit() {
      this.validateField();
      if (!this.productSelected.id) {
        Swal.fire({
          title: "Thêm danh mục",
          text: `Sản phẩm này sẽ được thêm vào danh sách`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "md-button md-success",
          cancelButtonClass: "md-button md-danger",
          confirmButtonText: "OK",
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
            this.checkIsExist();
          }
        });
      } else this.editProduct();
    },
    updateTags() {
      this.pushText(this.tag.type, this.form.type);
      this.pushText(this.tag.grapeVariety, this.form.grapeVariety);
      this.pushText(this.tag.foodPairing, this.form.foodPairing);
      this.pushText(this.tag.color, this.form.color);
      this.pushText(this.tag.flavor, this.form.flavor);
      this.pushText(this.tag.area, this.form.area);
      this.pushText(this.tag.packMethods, this.form.packMethods);
    },
    pushText(tag, a) {
      if (tag !== []) {
        a.splice(0, a.length);
        tag.forEach((item) => {
          a.push(item.text);
        });
      }
    },
    validateField() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] === undefined ? delete this.form[item] : "";
      });
    },
    editProduct() {
      Swal.fire({
        title: "Chỉnh sửa?",
        text: `Thông tin sản phẩm sẽ được thay đổi`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "OK",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch("FLAG_LOADING", true);
          this.updateTags();
          this.updateSuggestion();
          let date = new Date();
          this.form.creationTime = date.valueOf();
          let bits = localStorage.getItem("bits");
          this.form.discountValue = this.form.discountValue
            ? this.form.discountValue
            : 0;
          this.form.saleOffValue = this.form.saleOffValue
            ? this.form.saleOffValue
            : 0;
          console.log(this.additionalInfo1);
          this.form.additionalInfo =
            this.additionalInfo1[0] +
            "$jointPoint" +
            this.additionalInfo1[1] +
            "$jointPoint" +
            this.additionalInfo1[2];
          DAO.updateDocumentInFireStore(
            this.db,
            process.env.VUE_APP_WINE + bits,
            this.id,
            this.form
          )
            .then(() => {
              Swal.fire({
                title: "Thành công",
                text: "Đã thay đổi thông tin sản phẩm",
                timer: 1000,
                showConfirmButton: false,
              });
              this.$store.commit("EDIT_PRODUCT", this.id);
              this.$store.dispatch("FLAG_LOADING", false);
            })
            .catch((error) => {
              console.log(error);
              this.$store.dispatch("FLAG_LOADING", false);
            });
        }
      });
    },
    updateSuggestion() {
      let update = this.db
        .collection(process.env.VUE_APP_SUGGESTION_LIST)
        .doc("Products");
      // if (this.form.type) {
      //   let check = false;
      //   this.suggestion.wineType.forEach(item => {
      //     if (this.form.type === item) check = true;
      //   });
      //   if (!check) {
      //     update.update({
      //       wineType: firebase.firestore.FieldValue.arrayUnion(this.form.type)
      //     });
      //   }
      // }
      if (this.form.type !== []) {
        this.form.type.forEach((item) => {
          let check = false;
          this.suggestion.wineType.forEach((itemIm) => {
            if (itemIm === item) {
              check = true;
            }
          });
          if (!check) {
            update.update({
              wineType: firebase.firestore.FieldValue.arrayUnion(item),
            });
          }
        });
      }
      if (this.form.origin) {
        let check = false;
        this.suggestion.origin.forEach((item) => {
          if (this.form.origin === item) check = true;
        });
        if (!check) {
          update.update({
            origin: firebase.firestore.FieldValue.arrayUnion(this.form.origin),
          });
        }
      }
      if (this.form.manufacturer) {
        let check = false;
        this.suggestion.manufacturer.forEach((item) => {
          if (this.form.manufacturer === item) check = true;
        });
        if (!check) {
          update.update({
            manufacturer: firebase.firestore.FieldValue.arrayUnion(
              this.form.manufacturer
            ),
          });
        }
      }
      if (this.form.importer) {
        let check = false;
        this.suggestion.importer.forEach((item) => {
          if (this.form.importer === item) check = true;
        });
        if (!check) {
          update.update({
            importer: firebase.firestore.FieldValue.arrayUnion(
              this.form.importer
            ),
          });
        }
      }
      if (this.form.distributor) {
        let check = false;
        this.suggestion.distributor.forEach((item) => {
          if (this.form.distributor === item) check = true;
        });
        if (!check) {
          update.update({
            distributor: firebase.firestore.FieldValue.arrayUnion(
              this.form.distributor
            ),
          });
        }
      }
      // if (this.tag.tags !== []) {
      //   this.tag.tags.forEach(item => {
      //     let check = false;
      //     this.suggestion.tags.forEach(itemIm => {
      //       if (itemIm === item) {
      //         check = true;
      //       }
      //     });
      //     if (!check) {
      //       update.update({
      //         tags: firebase.firestore.FieldValue.arrayUnion(item)
      //       });
      //     }
      //   });
      // }
      // if (this.tag.area !== []) {
      //   this.tag.area.forEach(item => {
      //     let check = false;
      //     this.suggestion.area.forEach(itemIm => {
      //       if (item === itemIm) {
      //         check = true;
      //       }
      //     });
      //     if (!check) {
      //       update.update({
      //         area: firebase.firestore.FieldValue.arrayUnion(item)
      //       });
      //     }
      //   });
      // }
      // if (this.tag.grapeVariety !== []) {
      //   this.tag.grapeVariety.forEach(item => {
      //     let check = false;
      //     this.suggestion.grapeVariety.forEach(itemIm => {
      //       if (item === itemIm) {
      //         check = true;
      //       }
      //     });
      //     if (!check)
      //       update.update({
      //         grapeVariety: firebase.firestore.FieldValue.arrayUnion(item)
      //       });
      //   });
      // }
      // if (this.tag.foodPairing !== []) {
      //   this.tag.foodPairing.forEach(item => {
      //     let check = false;
      //     this.suggestion.foodPairing.forEach(itemIm => {
      //       if (item === itemIm) {
      //         check = true;
      //       }
      //     });
      //     if (!check)
      //       update.update({
      //         foodPairing: firebase.firestore.FieldValue.arrayUnion(item)
      //       });
      //   });
      // }
      // if (this.tag.color !== []) {
      //   this.tag.color.forEach(item => {
      //     let check = false;
      //     this.suggestion.color.forEach(itemIm => {
      //       if (item === itemIm) {
      //         check = true;
      //       }
      //     });
      //     if (!check)
      //       update.update({
      //         color: firebase.firestore.FieldValue.arrayUnion(item)
      //       });
      //   });
      // }
      // if (this.tag.packMethods !== []) {
      //   this.tag.packMethods.forEach(item => {
      //     let check = false;
      //     this.suggestion.packMethods.forEach(itemIm => {
      //       if (item === itemIm) {
      //         check = true;
      //       }
      //     });
      //     if (!check) {
      //       update.update({
      //         packMethods: firebase.firestore.FieldValue.arrayUnion(item)
      //       });
      //     }
      //   });
      // }
      // if (this.tag.flavor !== []) {
      //   this.tag.flavor.forEach(item => {
      //     let check = false;
      //     this.suggestion.flavor.forEach(itemIm => {
      //       if (item === itemIm) {
      //         check = true;
      //       }
      //     });
      //     if (!check)
      //       update.update({
      //         flavor: firebase.firestore.FieldValue.arrayUnion(item)
      //       });
      //   });
      // }
    },
    close() {
      if (this.isChange) {
        if (
          !confirm(
            "Bạn đã thay đổi thông tin sản phẩm. Bạn có chắc là muốn thoát?"
          )
        ) {
          return;
        }
      }
      if (this.form.pictureUrl.length && this.productSelected === {}) {
        this.$messageError("Xóa ảnh trước khi thoát");
      } else {
        this.$store.dispatch("SAVE_PRODUCT_SELECTED", this.$route.query.id);
        this.$router.go(-1);
      }
    },
  },
  computed: {
    ...mapGetters(["flagLoading"]),
    filteredArea() {
      return this.suggestion.area.filter((item) => {
        return (
          item.text.toLowerCase().indexOf(this.tags.area.toLowerCase()) !== -1
        );
      });
    },
    filterType() {
      return this.suggestion.wineType.filter((i) => {
        return i.toLowerCase().indexOf(this.tags.type.toLowerCase()) !== -1;
      });
    },
    filteredGrapeVariety() {
      return this.suggestion.grapeVariety.filter((i) => {
        return (
          i.text.toLowerCase().indexOf(this.tags.grapeVariety.toLowerCase()) !==
          -1
        );
      });
    },
    filteredPackMethods() {
      return this.suggestion.packMethods.filter((i) => {
        return (
          i.text.toLowerCase().indexOf(this.tags.packMethods.toLowerCase()) !==
          -1
        );
      });
    },
    filteredFlavor() {
      return this.suggestion.flavor.filter((i) => {
        return (
          i.text.toLowerCase().indexOf(this.tags.flavor.toLowerCase()) !== -1
        );
      });
    },
    filteredColor() {
      return this.suggestion.color.filter((i) => {
        return (
          i.text.toLowerCase().indexOf(this.tags.color.toLowerCase()) !== -1
        );
      });
    },
    filteredFoodPairing() {
      return this.suggestion.foodPairing.filter((i) => {
        return (
          i.text.toLowerCase().indexOf(this.tags.foodPairing.toLowerCase()) !==
          -1
        );
      });
    },
    filteredTags() {
      return this.suggestion.tags.filter((i) => {
        return (
          i.text.toLowerCase().indexOf(this.tags.tags.toLowerCase()) !== -1
        );
      });
    },
  },
  watch: {
    imageSelected() {
      console.log(true);
      let _this = this;
      new Compressor(this.form.pictureUrl[this.imageSelected].url, {
        maxWidth: 250,
        quality: 0.8,
        convertSize: 30000,
        mimeType: "image/png",
        success(result) {
          var fileReader = new FileReader();
          fileReader.readAsDataURL(result);
          fileReader.onload = function (event) {
            _this.form.pictureThumbnail = event.target.result;
            let bits = localStorage.getItem("bits");
            _this.db
              .collection(process.env.VUE_APP_WINE + bits)
              .doc(_this.productSelected.id)
              .update({ pictureThumbnail: _this.form.pictureThumbnail })
              .then();
          };
        },
        error(err) {},
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.add-img {
  padding: 20px;
  margin-left: 1vh;
  width: 20%;
  font-size: 17px;
  color: rgb(221, 44, 0);
}
.box-image {
  border-radius: 5px;
  margin-bottom: 30px;
}
.icon-remove {
  position: absolute;
}
.container {
  position: relative;
  width: 50%;
}

.image {
  opacity: 1;
  display: block;
  width: 100%;
  height: auto;
  transition: 0.5s ease;
  backface-visibility: hidden;
}

.middle {
  transition: 0.5s ease;
  opacity: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;
}

.container:hover .image {
  opacity: 0.3;
}

.container:hover .middle {
  opacity: 1;
}

.text {
  background-color: #4caf50;
  color: white;
  font-size: 16px;
  padding: 10px 20px;
  border-radius: 10px;
}
.radioSelectIcon {
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
}
@media only screen and (max-width: 600px) {
  .add-img {
    margin-left: 1vh;
    width: 25%;
    font-size: 17px;
    color: rgb(221, 44, 0);
  }
}
</style>
